package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

/**
 * Profile Response
 * User profile information
 */
@Serializable
data class ProfileResponseDto(
    val success: Boolean,
    val data: ProfileDataDto?,
)

/**
 * Profile Data
 * User profile details
 */
@Serializable
data class ProfileDataDto(
    val id: String,
    val email: String,
    val username: String?,
    val displayName: String?,
    val bio: String?,
    val profileComplete: Boolean,
    val onboardingCompleted: Boolean,
    val onboardingStep: String,
)

/**
 * Update Profile Request
 * Request to update user profile
 */
@Serializable
data class UpdateProfileRequestDto(
    val username: String? = null,
    val displayName: String? = null,
)
